<template>
  <div class="root-tag-component">
    <vs-dropdown vs-trigger-click class="cursor-pointer">
      <div class="d-flex">
        <vs-icon
            v-for="(color, index) in takeTwoColors"
            :key="index"
            :color="color"
            icon="label"
            size="small"
            :class="{
              'first-tag'   : index === 0,
              'another-tag' : index > 0
            }"
        ></vs-icon>
      </div>

      <vs-dropdown-menu>
        <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0" :settings="settings" :key="$vs.rtl">
          <vs-dropdown-item  v-for="(group, index) in groups" :key="index">
            <vs-icon icon="label" :color="group.color_tag"></vs-icon>
            <div class="group-name ml-4"> {{ group.name }} </div>
          </vs-dropdown-item>
        </VuePerfectScrollbar>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';
  import VsDropdown from "@/components/vs-dropdown/dropdown.vue";
  import VsDropdownMenu from "@/components/vs-dropdown/dropdown-menu.vue";
  import VsDropdownItem from "@/components/vs-dropdown/dropdown-item.vue";

  export default {
    name: 'TagComponent',
    data() {
      return {
        settings: {
          maxScrollbarLength: 60
        },
      }
    },
    props: {
      groups: {
        type: Array|Object,
        required: true
      }
    },
    computed:{
      takeTwoColors(){
        return this.groups.slice(0, 2).map((elem) => { return elem.color_tag || null })
      }
    },
    components: {
      VsDropdown,
      VsDropdownItem,
      VsDropdownMenu,
      VuePerfectScrollbar
    }
  }
</script>

<style lang="scss">
  .root-tag-component {
    display: flex;
    cursor: pointer;
  }

  .first-tag {
    z-index: 3;
  }

  .another-tag{
    z-index: 1;
    margin-top: -3px;
    margin-left: -18px;
  }

  .group-name {
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>